<ion-header>
  <ion-toolbar class="header-color ion-text-center">
    <ion-title>Promoga Chats</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="home"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  
  <ion-toolbar class="toolbar-container">
    <ion-buttons class="button-groups">
        <ion-button class="feature-buttons" [ngClass]="{'selected_feature_button':chatType === 'chat-room'}" (click)="chatType = 'chat-room'">
          Group Chats <span *ngIf="unreadChatCount" class="message-count">{{unreadChatCount}}</span>
        </ion-button>
        <ion-button class="feature-buttons" [ngClass]="{'selected_feature_button':chatType === 'dm'}" (click)="chatType = 'dm'">
          Direct Messages <span *ngIf="unreadDmCount" class="message-count">{{unreadDmCount}}</span>
        </ion-button>
    </ion-buttons>
</ion-toolbar>

  <div class="padding-20" *ngIf="!conversations || conversations.length <= 0">
       <p class="text-center title-no-reservation">You have no chatrooms.</p>
  </div>
  <ng-container *ngFor="let conversation of conversations; let i = index">
      <div class="chat-item" (click)="gotoChatRoom(conversation.id)" [ngClass]="{'unread-chat':conversation.is_unread}" 
      *ngIf="(chatType === 'chat-room' && conversation.chatType === 'chat-room') || (chatType === 'dm' && conversation.chatType === 'dm')">
        <div class="profile-pic">
          <img src="{{conversation.avatarUrl}}" alt="Profile Picture" (error)="onDmImageError($event)">
        </div>
        <div class="chat-details">
          <h5 class="username">{{ conversation.display_name }}</h5>
          <div class="flex-row">
            <div class="flex-start">
              <p class="members-count" *ngIf="conversation.chatType === 'chat-room' && conversation.members && conversation.members.count">{{ conversation.members.count}} users</p>
              <span *ngIf="conversation.is_unread" class="unread-msg-indicator">&#8226;</span>
              <p class="last-message" *ngIf="conversation.is_unread" [ngClass]="{'unread-last-message':conversation.is_unread}">{{ conversation.last_message ? conversation.last_message.text : ''}}</p>
            </div>
            <div class="flex-end">
              <span class="last-message-time" *ngIf="conversation.last_message">{{ (conversation.last_message ? conversation.last_message.created_at :'') | relativeTime }}</span>
            </div>
          </div>
         </div>
      </div>
  </ng-container>

</ion-content>
